<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-clipboard-list</v-icon>
        <span class="ml-2 title">Agregar encuesta</span>
        <v-spacer />
        <v-btn
          fab
          small
          color="secondary"
          @click="$router.go(-1)"
        >
          <v-icon>fas fa-arrow-left</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-form ref="encuesta">
              <v-text-field
                v-model="encuesta.descripcion"
                label="Descripción"
                :error-messages="errDescripcion"
              ></v-text-field>
              <v-text-field
                v-model="encuesta.fecha_inicio"
                type="datetime-local"
                label="Fecha de inicio"
                :error-messages="errFechaInicio"
              ></v-text-field>
              <v-text-field
                v-model="encuesta.fecha_fin"
                type="datetime-local"
                label="Fecha de fin"
                :error-messages="errFechaFin"
              ></v-text-field>
              <v-btn
                color="primary"
                class="mt-2"
                @click="saveEncuesta()"
              >
                <v-icon left>fas fa-save</v-icon>
                Guardar encuesta
              </v-btn>
            </v-form>
          </v-col>
          <v-col cols="12" md="6">
            <v-form ref="pregunta">
              <v-text-field
                v-model="pregunta.pregunta"
                label="Pregunta"
                :error-messages="errPregunta"
              ></v-text-field>
              <v-select
                v-model="pregunta.tipo"
                :items="tipos"
                item-text="text"
                item-value="value"
                label="Tipo de pregunta"
                :error-messages="errTipo"
              ></v-select>
              <v-combobox
                v-if="pregunta.tipo === 'multiple'"
                v-model="opciones"
                :items="[]"
                multiple
                chips
                clearable
                label="Ingresa las opciones"
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(item)"
                  >
                    <strong>{{ item }}</strong>&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
              <v-btn
                color="primary"
                class="mt-2"
                @click="addPregunta()"
              >
                <v-icon left>fas fa-plus</v-icon>
                Agregar pregunta
              </v-btn>
            </v-form>
            <p class="title my-2">Preguntas</p>
            <v-alert
              v-if="!preguntas.length"
              type="info"
              text
            >
              Agrega las preguntas
            </v-alert>
            <v-row
              v-else
              style="max-height: 400px; overflow-y: scroll;"
            >
              <v-col
                v-for="(item, index) in preguntas"
                :key="index"
                cols="12"
              >
                <v-card>
                  <div class="d-flex justify-space-between align-center pa-2">
                    <div>
                      <p class="subtitle-1 font-weight-bold my-1">{{ item.pregunta }}</p>
                      <p class="body-2 my-2">{{ item.tipo_text }}</p>
                      <div>
                        <v-chip
                          v-for="(opcion, index) in item.opciones"
                          :key="index"
                          class="ml-1"
                        >
                          {{ opcion }}
                        </v-chip>
                      </div>
                    </div>
                    <v-btn
                      color="error"
                      text
                      icon
                      @click="removePregunta(index)"
                    >
                      <v-icon>fas fa-trash</v-icon>
                    </v-btn>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import fechas from '../mixins/fechas'
export default {
  mixins: [fechas],
  data () {
    return {
      loading: false,
      encuesta: {
        descripcion: '',
        fecha_inicio: '',
        fecha_fin: ''
      },
      pregunta: {
        tipo: '',
        pregunta: ''
      },
      opciones: [],
      preguntas: [],
      tipos: [
        { text: 'Verdadero o falso', value: 'vf' },
        { text: 'Texto', value: 'texto' },
        { text: 'Opción multiple', value: 'multiple' }
      ]
    }
  },
  computed: {
    errDescripcion () {
      const errs = []
      if (!this.$v.encuesta.descripcion.$dirty) return errs
      !this.$v.encuesta.descripcion.required && errs.push('La descripción es requerida')
      return errs
    },
    errFechaInicio () {
      const errs = []
      if (!this.$v.encuesta.fecha_inicio.$dirty) return errs
      !this.$v.encuesta.fecha_inicio.required && errs.push('La fecha de inicio es requerida')
      return errs
    },
    errFechaFin () {
      const errs = []
      if (!this.$v.encuesta.fecha_fin.$dirty) return errs
      !this.$v.encuesta.fecha_fin.required && errs.push('La fecha de fin es requerida')
      return errs
    },
    errPregunta () {
      const errs = []
      if (!this.$v.pregunta.pregunta.$dirty) return errs
      !this.$v.pregunta.pregunta.required && errs.push('La pregunta requerida')
      return errs
    },
    errTipo () {
      const errs = []
      if (!this.$v.pregunta.tipo.$dirty) return errs
      !this.$v.pregunta.tipo.required && errs.push('Selecciona un tipo de pregunta')
      return errs
    }
  },
  methods: {
    async saveEncuesta () {
      this.$v.encuesta.$touch()
      if (!this.$v.encuesta.$invalid &&
        this.preguntas.length &&
        this.validateFechas(this.encuesta.fecha_inicio, this.encuesta.fecha_fin)) {
        try {
          this.loading = true
          const encuesta = await this.insertEncuesta()
          await this.insertPreguntas(encuesta.id)
          this.$router.push({ name: 'encuestas' })
          this.loading = false
        } catch (error) {
          window.alert('😅 Ha ocurrido un error al guardar los datos')
        }
      } else {
        window.alert('Completa los datos de la encuesta')
      }
    },
    async insertEncuesta () {
      const { data } = await this.$http.encuestas.post('', this.encuesta)
      return data
    },
    async insertPreguntas (encuestaID) {
      for (const item of this.preguntas) {
        const pregunta = {
          pregunta: item.pregunta,
          tipo: item.tipo,
          encuesta: encuestaID
        }
        const { data } = await this.$http.preguntas.post('', pregunta)
        if (item.tipo === 'multiple') {
          await this.insertOpciones(item.opciones, data.id)
        }
      }
    },
    async insertOpciones (opciones = [], preguntaID) {
      for (const item of opciones) {
        const opcion = {
          valor: item,
          pregunta: preguntaID
        }
        await this.$http.opciones.post('', opcion)
      }
    },
    remove (item) {
      this.opciones = this.opciones.filter(i => i !== item)
    },
    addPregunta () {
      this.$v.pregunta.$touch()
      if (!this.$v.pregunta.$invalid && this.validateMultiple()) {
        this.preguntas.push({
          ...this.pregunta,
          tipo_text: this.tipos.find(i => i.value === this.pregunta.tipo).text,
          opciones: [...this.opciones]
        })
        this.pregunta = {
          tipo: '',
          pregunta: ''
        }
        this.opciones = []
        this.$v.pregunta.$reset()
      }
    },
    validateMultiple () {
      if (this.pregunta.tipo === 'multiple' && this.opciones.length < 2) {
        window.alert('Agrega las opciones la pregunta')
        return false
      }
      return true
    },
    removePregunta (index) {
      this.preguntas.splice(index, 1)
    }
  },
  validations: {
    encuesta: {
      descripcion: { required },
      fecha_inicio: { required },
      fecha_fin: { required }
    },
    pregunta: {
      pregunta: { required },
      tipo: { required }
    }
  }
}
</script>
